import httpClient from '../../../../shared/services/http/http-client';
import { IRecieveEmailQuestionniare } from './email-questionnaire.model';

export default class EmailQuestionnaireService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getEmailQuestionnaire(token: string): Promise<IRecieveEmailQuestionniare> {
    return this.http.get(`/email-questionnaire?token=${token}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async filterData(categoryId: string, queryParams: string): Promise<any> {
    return this.http.get(`/email-questionnaire/filter/${categoryId}${queryParams}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  // async saveAnswers(token: string, details: IPostEmailQuestionairreResponse): Promise<any> {
  //   return this.http.post(`/email-questionnaire/save-answers?token=${token}`, details)
  //     .then(response => {
  //       return response.data
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       throw err
  //     });
  // }
}